import type { TextareaProps } from '@chakra-ui/react'
import { FormErrorMessage, Textarea } from '@chakra-ui/react'
import type { FieldError } from 'BrokerTsLib/src/rhf'
import { forwardRef } from 'react'

interface TextareaGroupProps extends TextareaProps {
  errors?: FieldError | undefined
}

export const TextareaGroup = forwardRef(({ errors, ...rest }: TextareaGroupProps, ref: any) => {
  const errorMessage = errors && errors?.message

  return (
    <>
      <Textarea {...rest} ref={ref} />

      {errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
    </>
  )
})
